var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[(_vm.cardConfig.type != null)?_c(_vm.cardConfig.type,{tag:"component",staticClass:"h-100",attrs:{"config":_vm.cardConfig,"layoutData":_vm.layoutData,"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }